import React, { useState } from 'react';
import { Modal, IconButton, Box, Typography } from '@mui/material';
import Close from '@mui/icons-material/Close';
import {
  GuideModalContainer,
  GuideModalHeader,
  GuideModalHeaderTitle,
  GuideModalBody,
  GuideSection,
  GuideSectionLabel,
  GuideText,
  GuideDivider,
} from '../../lesson/groupLesson/GroupLessonStyled';

const TABS = [
  { key: 'list', label: '임직원 목록' },
  { key: 'register', label: '등록/소속 추가' },
  { key: 'detail', label: '상세/수정' },
  { key: 'position', label: '직급 관리' },
];

const ListGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>📋 임직원 목록</GuideSectionLabel>
      <GuideText>
        현재 지점에 소속된 모든 임직원을 조회합니다.<br />
        • 상단 대시보드에서 전체 인원, 재직/퇴사, 담당업무별 현황을 확인할 수 있습니다.<br />
        • 이름 또는 전화번호로 검색할 수 있습니다. (하이픈 없이 번호만 입력해도 검색 가능)
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🔍 필터 및 정렬</GuideSectionLabel>
      <GuideText>
        <strong>필터</strong><br />
        • <strong>퇴사자 제외</strong> — 토글로 퇴사자를 목록에서 숨길 수 있습니다.<br />
        • <strong>직급 필터</strong> — 특정 직급만 필터링합니다.<br /><br />
        <strong>정렬</strong><br />
        • 입사일, 임직원명, 직급, 성별, 재직구분 컬럼의 화살표를 클릭하면 오름차순/내림차순/기본 순서로 전환됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>📱 앱 노출 여부</GuideSectionLabel>
      <GuideText>
        목록 우측의 토글로 회원앱 강사 목록 노출 여부를 설정합니다.<br />
        • <strong>노출</strong> — 회원앱에서 강사 목록에 표시됩니다.<br />
        • <strong>비노출</strong> — 회원앱에서 해당 강사가 보이지 않습니다.<br />
        • 토글 변경 시 확인 알림이 표시되며, 즉시 반영됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>📊 엑셀 다운로드</GuideSectionLabel>
      <GuideText>
        현재 조회된 임직원 목록을 엑셀 파일로 다운로드할 수 있습니다.<br />
        필터가 적용된 상태에서 다운로드하면 필터된 결과만 포함됩니다.
      </GuideText>
    </GuideSection>
  </>
);

const RegisterGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>🔗 기존 강사 소속 추가</GuideSectionLabel>
      <GuideText>
        강사앱에서 이미 회원가입한 강사를 현재 지점에 소속시킵니다.<br /><br />
        우측 상단 <strong>"임직원 등록"</strong>을 클릭하면 바로 검색 모달이 열립니다.<br /><br />
        • 아이디, 이름, 전화번호로 검색합니다.<br />
        • 검색 결과에서 <strong>"추가"</strong> 버튼을 클릭하면 인사정보 등록 화면이 나옵니다.<br />
        • 입사일, 재직상태, 회원앱 노출 여부, 담당업무, 종목을 입력 후 등록합니다.<br />
        • 이미 소속된 강사는 "소속됨"으로 표시됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⚠️ 주의사항</GuideSectionLabel>
      <GuideText>
        • 강사는 강사앱에서 먼저 회원가입을 완료해야 검색으로 추가할 수 있습니다.<br />
        • 한 강사가 여러 지점에 소속될 수 있습니다. (다지점 지원)
      </GuideText>
    </GuideSection>
  </>
);

const DetailGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>👤 임직원 상세</GuideSectionLabel>
      <GuideText>
        목록에서 임직원을 클릭하면 상세 페이지로 이동합니다.<br /><br />
        <strong>기본 정보 탭</strong><br />
        • 이름, 전화번호, 이메일, 생년월일, 성별, 프로필 이미지 등을 수정할 수 있습니다.<br />
        • 인사 정보(입사일, 직급, 담당업무, 종목 등)도 함께 수정합니다.<br /><br />
        <strong>담당 회원 탭</strong><br />
        • 해당 강사에게 배정된 회원 목록을 확인합니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🔐 비밀번호/계정 설정</GuideSectionLabel>
      <GuideText>
        임직원 상세 페이지에서 비밀번호와 계정 관련 설정을 관리합니다.<br /><br />
        • <strong>비밀번호 변경</strong> — 관리자가 직원의 비밀번호를 재설정할 수 있습니다.<br />
        • <strong>매니저앱 로그인</strong> — 매니저앱 로그인 허용/차단을 설정합니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🚪 출입 관리</GuideSectionLabel>
      <GuideText>
        안면인식 출입 시스템이 연동된 경우, 출입 그룹을 설정할 수 있습니다.<br />
        • 출입 가능한 구역(출입 그룹)을 선택하여 강사의 출입 권한을 관리합니다.
      </GuideText>
    </GuideSection>
  </>
);

const PositionGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>📂 직급 관리란?</GuideSectionLabel>
      <GuideText>
        지점 내 임직원의 직급을 등록하고 관리합니다.<br />
        직급은 임직원 등록/수정 시 선택할 수 있으며, 임직원 목록에서 직급별 필터링이 가능합니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>➕ 직급 등록</GuideSectionLabel>
      <GuideText>
        • 직급명과 직급 순서를 입력하여 추가합니다.<br />
        • <strong>직급 순서</strong>는 1 이상의 숫자여야 하며, 중복이 불가능합니다.<br />
        • 직급 순서에 따라 임직원 목록과 권한 관리 등에서 표시 순서가 결정됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>✏️ 직급 수정</GuideSectionLabel>
      <GuideText>
        • 목록에서 수정 버튼을 클릭하면 해당 행에서 직접 수정할 수 있습니다.<br />
        • 직급명과 직급 순서를 변경할 수 있습니다.<br />
        • 수정 시 확인 모달이 표시됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🗑️ 직급 삭제</GuideSectionLabel>
      <GuideText>
        • 각 행의 삭제 버튼 또는 체크박스 선택 후 선택 삭제를 사용합니다.<br />
        • 삭제 시 해당 직급에 소속된 <strong>직원 수와 명단</strong>이 표시됩니다.<br />
        • 삭제가 확정되면 해당 직원들의 직급이 <strong>자동으로 해제</strong>됩니다.<br />
        • 삭제된 직급은 복구할 수 없습니다.
      </GuideText>
    </GuideSection>
  </>
);

const TAB_CONTENT = {
  list: ListGuide,
  register: RegisterGuide,
  detail: DetailGuide,
  position: PositionGuide,
};

const EmployeeGuideModal = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState('list');
  const TabContent = TAB_CONTENT[activeTab];

  return (
    <Modal open={open} onClose={onClose} disableScrollLock>
      <GuideModalContainer>
        <GuideModalHeader>
          <GuideModalHeaderTitle>임직원 관리 가이드</GuideModalHeaderTitle>
          <IconButton onClick={onClose} sx={{ color: '#fff', p: '4px' }}>
            <Close />
          </IconButton>
        </GuideModalHeader>

        {/* 탭 */}
        <Box sx={{
          display: 'flex', borderBottom: '1px solid #e0e0e0', flexShrink: 0, backgroundColor: '#fafafa',
        }}>
          {TABS.map(tab => (
            <Box
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              sx={{
                flex: 1, textAlign: 'center', padding: '12px 0', cursor: 'pointer',
                fontSize: '13px', fontWeight: activeTab === tab.key ? 700 : 500,
                fontFamily: 'Pretendard, sans-serif',
                color: activeTab === tab.key ? '#4AB3BC' : '#888',
                borderBottom: activeTab === tab.key ? '2px solid #4AB3BC' : '2px solid transparent',
                transition: 'all 0.15s ease',
                '&:hover': { color: '#4AB3BC', backgroundColor: '#f0f8f8' },
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>

        <GuideModalBody>
          <TabContent />
        </GuideModalBody>
      </GuideModalContainer>
    </Modal>
  );
};

export default EmployeeGuideModal;
